import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import {UserModel} from 'src/app/models/user.model'
import { RoleModel } from '../models/role.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  
  constructor(private http : HttpClient) {

   }

getlistroles() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/organization/listroles" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }


  

  getlistprivileges() {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/organization/getallprivileges" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }
  getrole(userid:any,code:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/auth/maproles?userid="+userid+"&code="+code ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
  }
  saveRole(role:RoleModel) {
    console.log(role)
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/organization/role",role,{headers : headers,observe:"response"});
   }
   getRoleList() {
      
    let httpParam : HttpParams=new HttpParams();
   

    return this.http.get( environment.API_URL + '/api/crm/roleidname',{ observe : "body", params : httpParam,responseType : "json"})
    
  }
  getRoleTravellerList() {
      
    let httpParam : HttpParams=new HttpParams();
   

    return this.http.get( environment.API_URL + '/api/crm/business-roleidname',{ observe : "body", params : httpParam,responseType : "json"})
    
  }

  getUserError() {
      
    let httpParam : HttpParams=new HttpParams();
   

    return this.http.get( environment.API_URL + '/api/app/upload/list',{ observe : "body", params : httpParam,responseType : "json"})
    
  }
  getpdf(fileName:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/app/upload/download/"+fileName ,{headers : header, observe : "response", params : httpParam,responseType : "blob"})  
  }
  confirm(){
    const formData: FormData = new FormData();
    formData.append('returnUrl1', 'https://vapt.gilpinonline.com/payment/payment/cca/confirm');
    formData.append('encResp','70318a5082a49c95088d9fd86969aa0eb70c6b2e2f2bd6a87cc10fba96dad09ebffef0ac5b0c3336296a6a18876583cb2d65e5dec18c1726348b97365d6670309e007d477d0f0eee3ab91214e6affd298f93011780247d497136a215f8da1ff8b9b9993294b3f44e07b6d2e80ba491de2725ad187af17a5e977dd8d5688d22e3329cf20a906b42f3cdfc93c4a73854c78a3798c9c0fc818e669bee2a45e2140df43f3e070649b4674abdf4a29165f23b1155aede6a5aae9101bc7733a36cb543ce2e90950f19a0b2368585796c95d22b459ebff4d80635d9fd407de744ce3139c23f2df3b6c2c6473e355202ed4d4e8cc85adbe7f7373a9ce362e110ce22a8895891cb56dd78037abfa97e04c31e82ac0c677843f56174378cc76632d26fa33e9fe3a8b92ba97269587ef220afae0cb8d627eed119463665d0809979081a4063274c99afbd84dea670c01537f02e53a10f911f98cdfab5a11b1a138d03e44f72986bf02b0b8b176542324977a0852196f400b3963d771127136e8b60e337177a885873d3fbf1ef8eebd88833053e4d3e501fa397e1a2ebf1979e564f5365cbc41554b0daa416a48e6e4fedaf9c7aa4be3136b11a02e7933a53953e36a80d84be0f30d8c0cbf9ff77c2f4320eb3387bd5e1bcd5804d2c307af781ddf7410d8616b9aaac55c95ee429fbebb42d3d7ec0f3e9102b796799751880bff1075886103d5129a69bd190f248cb2a5a1f053100672e3636a2eb699553b01a6e90e91e6bcc7b136a2601a09639347ecd8cf6aeea710b012ca45055c650d0c23cfe4556bb5380f120b6a68b421b33acf3d10956e143060feadff81cdb788b8c7ef518839133136af6137788ed33ef8c956634a9c931d710bdfa8eb9e6b0c2cc43b25389c31b51f5900fc185a777c26c33d37ee89ed61dc9522673348c6e6410c0e343a8fb1f6b5993a49a0ebcbadc95dd84faa7303910f832fcd394d5add4a31b3eb2a366c41f81924ab7b8342a44dac7ce8fea2867e7f89ab1eaca3cdc6faa21210025d7a9a2e5092c38418d3fc8d12ce52adc09661f7360630d6a8adc16e69a99b9ecaa34267656980e1c1dae105312d12ab04f9f');
    formData.append('orderNo','dy5BWwC86RDz17a5OeZb74eJKFhEv4');

    return this.http.post(environment.API_URL+"/payment/payment/cca/confirm",formData,{observe:"response"});

  }






   registerUser(user : any) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/crm/user",user,{headers : headers,observe:"response"});
   }

   updateUserInfo(user:any,email:String) {
    console.log(user)
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/crm/user/"+email,user,{headers : headers,observe:"response"});
   }
   updateGstInfo(user:any,email:String) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/crm/user/gstinfo/"+email,user,{headers : headers,observe:"response"});
   }
   updateContactInfo(user:any,email:String) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/crm/user/contactinfo/"+email,user,{headers : headers,observe:"response"});
   }
   updateProfileInfo(user:any) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/crm/userProfile/save",user,{headers : headers,observe:"response"});
   }
   getAllUser(request:{page:any,size:any},search:{searchText:any,userType:any,status:any,mobile:any,branchId:any}) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
        httpParam=httpParam.append("page", request.page);
        httpParam=httpParam.append("size", request.size);
        httpParam=httpParam.append("searchText", search.searchText);
        httpParam=httpParam.append("userType", search.userType);
        httpParam=httpParam.append("status", search.status);
        httpParam=httpParam.append("mobile", search.mobile);
        httpParam=httpParam.append("branchId", search.branchId);

      return this.http.get( environment.API_URL+"/api/crm/users" ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
   
  }

  
   verifyEmail(emailId:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/crm/user/validate/"+emailId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }

  getUserData(emailId:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/crm/user/"+emailId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
  }
  getUserList(userType: any): Observable<any> {
    const headers = new HttpHeaders();
    const httpParams = new HttpParams().set("searchText", "");

    return this.http.post(environment.API_URL + "/api/crm/allUsers", '', { headers, params: httpParams });
  }

  ENABLE_TRIP_MGMT(){
    
    const headers = new HttpHeaders();
    const httpParams = new HttpParams()

    return this.http.get(environment.API_URL + "/api/policy/rule/ALL/CORPORATE/TRIP_MGMT/ENABLE_TRIP_MGMT", {  observe : "body", params : httpParams,responseType : "json"});
 
  }
  uploadUserExcel(userListFile:File,bulkUserData:any) {
    console.log(userListFile);
    console.log(bulkUserData);
    let contenttype= undefined;
    const formData = new FormData();
    formData.append("file", userListFile)
    //formData.append("userParams",JSON.stringify(bulkUserData), { type: 'text/plain' );
    formData.append('userParams', new Blob([JSON.stringify(bulkUserData)], {
      type: 'application/json'
    }));
    let header = new HttpHeaders();
    //let headers = new HttpHeaders({ 'Content-Type': });

    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/crm/user/bulkuser",formData ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  }


  getUserbyUUid(uuid:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/crm/user/info/"+uuid ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
  }


  async getUserPrivileges(): Promise<any> {
    try {
      let httpParam : HttpParams=new HttpParams();
      const response = await this.http.get<any>( environment.API_URL + '/api/crm/userprivileges',{ observe : "body", params : httpParam,responseType : "json"}).toPromise();
      return response;
    } catch (error) {
      // Handle errors here (e.g., log or display an error message)
      throw error;
    }
  }
  async getUserTravellerPrivileges(): Promise<any> {
    try {
      let httpParam : HttpParams=new HttpParams();
      const response = await this.http.get<any>( environment.API_URL + '/api/crm/userbusinessprivileges',{ observe : "body", params : httpParam,responseType : "json"}).toPromise();
      return response;
    } catch (error) {
      // Handle errors here (e.g., log or display an error message)
      throw error;
    }
  }

  ccaOrder(request:any) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/pg/cca/order",request,{headers : headers,observe:"response"});
   }
   paymentOrderData(orderId:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.get( environment.API_URL+"/api/pg/cca/"+orderId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})
  }
   synctickets() {
    let headers = new HttpHeaders();
    return this.http.get(environment.API_URL+"/api/app/crm/synctickets",{ observe : "body",responseType : "json"});
   }
   passportUpdate(request:any) {
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/crm/userProfile/uploadDocument",request,{observe:"response"});
   }
   downloadPassport(passport:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
     httpParam=httpParam.append("name", passport);
     httpParam=httpParam.append("type", 'passport');

      return this.http.get( environment.API_URL+"/api/crm/userProfile/downloadDocument",{ observe : "body", params : httpParam,responseType : "blob"})  
  }
  downloadVisa(passport:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
     httpParam=httpParam.append("name", passport);
     httpParam=httpParam.append("type", 'visa');

      return this.http.get( environment.API_URL+"/api/crm/userProfile/downloadDocument",{ observe : "body", params : httpParam,responseType : "blob"})  
  }
}
